import { c as _c } from "react-compiler-runtime";
import React from "react";
import { Group, Label, ProgressBar as AriaProgressBar } from "react-aria-components";
import { Circle } from "../icons/line.js";
import { bar, barFill, container, dot, label, progressValue } from "./ProgressBar.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BaseProgressBar = (t0, ref) => {
  const $ = _c(36);
  let hideInactiveDots;
  let labelText;
  let progressLabel;
  let props;
  let t1;
  let t2;
  let t3;
  let value;
  if ($[0] !== t0) {
    ({
      dots: t1,
      label: labelText,
      value,
      type: t2,
      hideInactiveDots,
      animated: t3,
      progressLabel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = hideInactiveDots;
    $[2] = labelText;
    $[3] = progressLabel;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = value;
  } else {
    hideInactiveDots = $[1];
    labelText = $[2];
    progressLabel = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    value = $[8];
  }
  const dots = t1 === undefined ? 0 : t1;
  const type = t2 === undefined ? "bar" : t2;
  const animated = t3 === undefined ? false : t3;
  let t4;
  if ($[9] !== dots || $[10] !== hideInactiveDots || $[11] !== value) {
    t4 = () => Array.from({
      length: dots
    }).map((_, index) => {
      const isActive = index <= Math.floor(value * dots / 100);
      return /*#__PURE__*/_jsx(Circle, {
        stroke: "none",
        className: dot({
          active: isActive,
          hide: hideInactiveDots === true && !isActive
        })
      }, index);
    });
    $[9] = dots;
    $[10] = hideInactiveDots;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const renderedDots = t4;
  let t5;
  if ($[13] !== labelText) {
    t5 = labelText != null && /*#__PURE__*/_jsx(Label, {
      className: label,
      children: labelText
    });
    $[13] = labelText;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== progressLabel || $[16] !== type) {
    t6 = container({
      type,
      progressLabel
    });
    $[15] = progressLabel;
    $[16] = type;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== animated || $[19] !== renderedDots || $[20] !== type || $[21] !== value) {
    t7 = type === "dots" ? renderedDots() : /*#__PURE__*/_jsx(Group, {
      className: bar,
      children: /*#__PURE__*/_jsx(Group, {
        className: barFill({
          animated
        }),
        style: {
          width: `${value}%`
        }
      })
    });
    $[18] = animated;
    $[19] = renderedDots;
    $[20] = type;
    $[21] = value;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== progressLabel || $[24] !== value) {
    t8 = progressLabel && /*#__PURE__*/_jsxs(Group, {
      className: progressValue,
      children: [value, "%"]
    });
    $[23] = progressLabel;
    $[24] = value;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t9 = /*#__PURE__*/_jsxs(Group, {
      className: t6,
      children: [t7, t8]
    });
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== props || $[31] !== ref || $[32] !== t5 || $[33] !== t9 || $[34] !== value) {
    t10 = /*#__PURE__*/_jsxs(AriaProgressBar, {
      ref: ref,
      value: value,
      ...props,
      children: [t5, t9]
    });
    $[30] = props;
    $[31] = ref;
    $[32] = t5;
    $[33] = t9;
    $[34] = value;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
};
export const ProgressBar = /*#__PURE__*/React.forwardRef(BaseProgressBar);
//# sourceMappingURL=ProgressBar.js.map